import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const YOUTH_CAMP_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'YouthCamp',
    column_type: 'id',
  },
  created_at: {
    model_name: 'YouthCamp',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'YouthCamp',
    column_type: 'datetime',
  },
  title: {
    model_name: 'YouthCamp',
    column_type: 'string',
  },
  type: {
    model_name: 'YouthCamp',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  likes_count: {
    model_name: 'YouthCamp',
    column_type: 'integer',
  },
  views_count: {
    model_name: 'YouthCamp',
    column_type: 'integer',
  },
  stars_count: {
    model_name: 'YouthCamp',
    column_type: 'integer',
  },
  shares_count: {
    model_name: 'YouthCamp',
    column_type: 'integer',
  },
  comments_count: {
    model_name: 'YouthCamp',
    column_type: 'integer',
  },
  published_at: {
    model_name: 'YouthCamp',
    column_type: 'datetime',
  },
  author: {
    model_name: 'YouthCamp',
    column_type: 'string',
  },
  source: {
    model_name: 'YouthCamp',
    column_type: 'string',
  },
  share_desc: {
    model_name: 'YouthCamp',
    column_type: 'string',
  },
  is_top: {
    model_name: 'YouthCamp',
    column_type: 'boolean',
  },
  content_type: {
    model_name: 'YouthCamp',
    column_type: 'enum',
  },
  number: {
    model_name: 'YouthCamp',
    column_type: 'integer',
  },
  start_at: {
    model_name: 'YouthCamp',
    column_type: 'datetime',
  },
  end_at: {
    model_name: 'YouthCamp',
    column_type: 'datetime',
  },
  lecturer: {
    model_name: 'YouthCamp',
    column_type: 'string',
  },
  address: {
    model_name: 'YouthCamp',
    column_type: 'string',
  },
  applicants_count: {
    model_name: 'YouthCamp',
    column_type: 'integer',
  },
  price_type_template: {
    model_name: 'YouthCamp',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'price_type_template',
      model_name: 'PriceTypeTemplate',
      foreign_key: 'price_type_template_id',
    },
  },
  price_type_template_id: {
    model_name: 'YouthCamp',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'price_type_template',
      model_name: 'PriceTypeTemplate',
      foreign_key: 'price_type_template_id',
    },
  },
  cover: {
    model_name: 'YouthCamp',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  note: {
    model_name: 'YouthCamp',
    column_type: 'string',
  },
  content: {
    model_name: 'YouthCamp',
    column_type: 'text',
  },
  markdown_content: {
    model_name: 'YouthCamp',
    column_type: 'text',
  },
  images: {
    model_name: 'YouthCamp',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
